import $ from 'jquery';

export default class MegamenuNav {
    constructor() {
        if ($('.js-megamenu-nav').length) {
            $('.js-megamenu__open').on('click', function() {
                $(this).addClass('is-invisible');
                $('.js-megamenu__close').removeClass('is-invisible');
                $('#modal-nav').foundation('toggle');
            });

            $('.js-megamenu__close').on('click', function() {
                $('#modal-nav').foundation('toggle');
            });

            $('body').on('click', '.js-megamenu-nav__primary-link', function() {
                const $this = $(this);

                if($this.hasClass('is-active')) {
                    $('.js-megamenu-nav__primary-link').removeClass('is-active');

                    if(Foundation.MediaQuery.is('small only')) {
                        $('.js-megamenu-nav__secondary-links').slideUp();
                    } else {
                        $('.js-megamenu-nav__secondary-links').fadeOut();
                    };
                } else {
                    $('.js-megamenu-nav__primary-link').removeClass('is-active');

                    if(Foundation.MediaQuery.is('small only')) {
                        $('.js-megamenu-nav__secondary-links').slideUp();

                        // Slide in selected subnav
                        $this.addClass('is-active');
                        $this.find('.js-megamenu-nav__secondary-links').slideDown();
                    } else {
                        $('.js-megamenu-nav__secondary-links').fadeOut();

                        // Fade in selected subnav
                        $this.addClass('is-active');
                        $this.find('.js-megamenu-nav__secondary-links').fadeIn();
                    };
                };
            });

            // Reset navigation when megamenu closed
            $(document).on('closed.zf.reveal', '.js-megamenu', function () {
                $('.js-megamenu-nav__primary-link').removeClass('is-active');
                $('.js-megamenu-nav__secondary-links').hide();
                $('.js-megamenu__open').removeClass('is-invisible');
                $('.js-megamenu__close').addClass('is-invisible');
            });
        };
    };
};
